module.exports = __webpack_public_path__ + "media/images/boa-icon-35c61696b31ee134eb61989ce9975e24.png";